import EnhancedContentManifestRecord from "models/view-models/enhanced-content-manifest-record";
import ServiceFactory from "../service-factory";

// ---------------------------------------------------------------------------------------------
// #region Constants
// ---------------------------------------------------------------------------------------------

const baseEndpoint =
    "publications/:code/:edition/chapters/:chapterNfpaLabel/enhanced-content-manifests";

interface EnhancedContentBasePathParams {
    code: string;
    edition: string;
    chapterNfpaLabel: string;
}

interface EnhancedContentQueryParams {}

// #endregion Constants

// ---------------------------------------------------------------------------------------------
// #region Service
// ---------------------------------------------------------------------------------------------
const EnhancedContentChapterManifestsService = {
    list: ServiceFactory.nestedList<
        EnhancedContentManifestRecord,
        EnhancedContentBasePathParams,
        EnhancedContentQueryParams
    >(EnhancedContentManifestRecord, baseEndpoint),
};

// #endregion Service

// ---------------------------------------------------------------------------------------------
// #region Exports
// ---------------------------------------------------------------------------------------------

export default EnhancedContentChapterManifestsService;

// #endregion Exports
